<script setup lang="ts">
  import { computed } from 'vue';
  import { HoverListTooltip } from '@/shared/ui';
  import type { TrainingCollaboratorPosition } from '@/entities/Training';

  const props = defineProps<{
    positions: TrainingCollaboratorPosition[];
  }>();

  const label = computed(
    () => `${props.positions.length} cargo${props.positions.length !== 1 ? 's' : ''}`
  );

  const title = computed(() => `Cargos (${props.positions.length})`);

  const items = computed(() =>
    props.positions.map((position) => ({ id: position.id, text: position.name }))
  );
</script>

<template>
  <HoverListTooltip
    :label="label"
    :title="title"
    :items="items"
    test-id="collaborator-positions-tooltip"
  />
</template>
